/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import { initialLetters } from '../../../../app/utils/initialLetters'
import { getAvatarUrl } from '../../../helpers'
import { tempoPassado } from '../../../../app/utils/date'
import { getContrastColor } from '../../../../app/utils/contratColor'

const VISION_PRIMARY = '#ffc700'

const HeaderUserMenu: FC = () => {
  const {currentUser, logout} = useAuth()
  const [avatarNotFound, setAvatarNotFound] = useState(false);
  const isDemo = currentUser?.account_type === 'DEMO'
  const companyColor = currentUser?.companies?.[0]?.color_primary || VISION_PRIMARY
  const companyTextColor = getContrastColor(companyColor)
  const demoExpiresLabel = (() => {
    if (!isDemo || !currentUser?.data_expiracao) return ''
    const raw = typeof currentUser.data_expiracao === 'string'
      ? currentUser.data_expiracao
      : new Date(currentUser.data_expiracao).toISOString()
    const expiresAt = new Date(currentUser.data_expiracao)
    if (Number.isNaN(expiresAt.getTime())) return ''
    if (expiresAt.getTime() <= Date.now()) return 'Período encerrado'
    return `Expira ${tempoPassado(raw)}`
  })()

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6'
      style={{width: 'auto', minWidth: '275px', maxWidth: '400px'}}
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            {currentUser?.avatar && !avatarNotFound ? (
              <img alt='Avatar' src={getAvatarUrl(currentUser.avatar)} onError={() => setAvatarNotFound(true)} />
            ) : (
              <span className={`symbol-label bg-light-primary text-primary fs-6 fw-bolder`}>
                  {currentUser ? initialLetters(currentUser.name) : "Não identificado."}
              </span>
            )}
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-6'>
              {currentUser?.first_name} {currentUser?.name}
              {isDemo && (
                <span className='badge badge-light-warning fw-bolder fs-8 px-2 py-1 ms-2'>
                  DEMO
                </span>
              )}
            </div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {currentUser?.email}
            </a>
            {isDemo && demoExpiresLabel && (
              <span
                className='badge fs-8 mt-1 align-self-start fw-bolder'
                style={{ backgroundColor: companyColor, color: companyTextColor }}
              >
                {demoExpiresLabel}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <Link to={'/perfilSettings'} className='menu-link px-5'>
          Meu perfil
        </Link>
      </div>

      {/* <div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          <span className='menu-text'>My Projects</span>
          <span className='menu-badge'>
            <span className='badge badge-light-danger badge-circle fw-bolder fs-7'>3</span>
          </span>
        </a>
      </div> */}

      {/* <div
        className='menu-item px-5'
        data-kt-menu-trigger='hover'
        data-kt-menu-placement='left-start'
        data-kt-menu-flip='bottom'
      >
        <a href='#' className='menu-link px-5'>
          <span className='menu-title'>My Subscription</span>
          <span className='menu-arrow'></span>
        </a>

        <div className='menu-sub menu-sub-dropdown w-175px py-4'>
          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Referrals
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Billing
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Payments
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link d-flex flex-stack px-5'>
              Statements
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='View your statements'
              ></i>
            </a>
          </div>

          <div className='separator my-2'></div>

          <div className='menu-item px-3'>
            <div className='menu-content px-3'>
              <label className='form-check form-switch form-check-custom form-check-solid'>
                <input
                  className='form-check-input w-30px h-20px'
                  type='checkbox'
                  value='1'
                  defaultChecked={true}
                  name='notifications'
                />
                <span className='form-check-label text-muted fs-7'>Notifications</span>
              </label>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          My Statements
        </a>
      </div> */}

      <div className='separator my-2'></div>

      {/* <Languages /> */}

      <div className='menu-item px-5 my-1'>
        <Link to={currentUser?.role.slug === "EMPRESA" ? '/companySettings' : currentUser?.role.slug === "CLIENTE" ? '/clientSettings' : currentUser?.role.slug === "FILIAL" ? "unitBranchSettings" : ""} className='menu-link px-5'>
          Configuração da conta
        </Link>
      </div>

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          Sair
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
